import React from 'react';
import styled from 'styled-components';
import DashboardLayout from '../../components/layouts/dashboard/DashboardLayout';
import { colors, typography } from '../../styles/theme';

const WelcomeCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const WelcomeTitle = styled.h2`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xl};
  color: ${colors.text.primary};
  margin: 0 0 16px 0;
`;

const WelcomeText = styled.p`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.base};
  color: ${colors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

const Overview = () => {
  return (
    <DashboardLayout title="Overview" currentPath="/dashboard">
      <WelcomeCard>
        <WelcomeTitle>Welcome to Your Dashboard</WelcomeTitle>
        <WelcomeText>
          Manage your policies, submit claims, and track your ESG impact all in one place.
          Use the navigation menu to explore different sections of your dashboard.
        </WelcomeText>
      </WelcomeCard>
    </DashboardLayout>
  );
};

export default Overview; 